export default __webpack_public_path__ + "static/media/NON_PROFIT.40cdc819.png";